export const WAKE_UP_REQUEST = 'WAKE_UP_REQUEST'
export const WAKE_UP_SUCCESS = 'WAKE_UP_SUCCESS'
export const WAKE_UP_FALIURE = 'WAKE_UP_FALIURE'
